import React from "react";
import { SelectBox } from "devextreme-react/select-box";
import DateRangePicker from "../../Shared/DateRangePicker";

/**
 * Filters sent to Rides/get-rides: date range (shared picker) and airport, then Search.
 * filters = { from, to, airportCode }. Rides are always loaded for every status; the status tiles filter them on the page; onChange(partial); onSearch().
 */
export default function DispatchFilterBar({ filters, airports, searching, onChange, onSearch }) {
  return (
    <section className="dsp-filters" aria-label="Filters">
      <div className="dsp-field dsp-field--date">
        <label>From - To date</label>
        <DateRangePicker
          startDate={filters.from}
          endDate={filters.to}
          isClearable={false}
          ariaLabel="From - To date"
          onChange={([from, to]) => onChange({ from, to })}
        />
      </div>
      <div className="dsp-field dsp-field--airport">
        <label>Airport</label>
        <SelectBox
          dataSource={airports}
          displayExpr="airportName"
          valueExpr="airportCode"
          value={filters.airportCode || null}
          placeholder="All airports"
          showClearButton
          searchEnabled
          inputAttr={{ "aria-label": "Airport" }}
          onValueChanged={(e) => onChange({ airportCode: e.value ?? "" })}
        />
      </div>
      <div className="dsp-field dsp-field--action">
        <button type="button" className="btn btn-primary btn-sm dsp-search" disabled={searching} onClick={onSearch}>
          <i className={`fas fa-${searching ? "spinner fa-spin" : "search"}`} aria-hidden="true" /> Search
        </button>
      </div>
    </section>
  );
}
